import React, { useEffect, useState } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import AmountInput from 'components/amount-input';
import SingleBottomNav from 'components/base/single-bottom-nav';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { useParams } from 'react-router-dom';
import useEditShopContext from 'contexts/shop.context';

type Props = {
  onEditComplete: () => void;
};

const EditShopFees = ({ onEditComplete }: Props) => {
  const { shopDetails, setShopDetails, setDisabled } = useEditShopContext();
  const [loading, setLoading] = useState(false);
  const { shop_id } = useParams();

  const handleChange = (field: keyof typeof shopDetails, value: string, allowDecimal = false) => {
    let numericValue = value;

    numericValue = allowDecimal
      ? numericValue.replace(/[^0-9.]/g, '')
      : numericValue.replace(/[^0-9]/g, '');

    setShopDetails({
      ...shopDetails,
      [field]: numericValue === '' ? '' : Number(numericValue)
    });
  };

  const handleUpdateShop = async () => {
    setLoading(true);
    try {
      const payload = {
        platform_fee: shopDetails.platform_fee,
        platform_fee_cap: shopDetails.platform_fee_cap,
        service_fee: shopDetails.service_fee,
        service_fee_cap: shopDetails.service_fee_cap
      };

      await apiService.put(`shops/${shop_id}`, { data: payload });

      onEditComplete();
      toast(<ToastMessage type='success' message='Shop fees updated successfully' />);
    } catch {
      toast(<ToastMessage type='error' message='There was a problem updating shop fees' />);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const isDisabled =
      shopDetails?.platform_fee == null ||
      shopDetails?.platform_fee_cap == null ||
      shopDetails?.service_fee == null ||
      shopDetails?.service_fee_cap == null;

    setDisabled(isDisabled);
  }, [shopDetails]);

  return (
    <div>
      <Input
        type='number'
        label='Platform Fee %'
        placeholder='Enter percentage'
        className='w-full mt-4'
        inputClass='px-[20px] py-[14px]'
        value={shopDetails?.platform_fee ?? ''}
        min={0}
        max={1}
        step={0.01}
        onChange={(e) => handleChange('platform_fee', e.target.value, true)}
      />

      <AmountInput
        type='text'
        label='Platform Fee Cap (₦)'
        placeholder='Enter cap amount'
        className='w-full mt-4'
        value={shopDetails?.platform_fee_cap === 0 ? '' : shopDetails?.platform_fee_cap}
        min={0}
        step={1}
        onChange={(e) => handleChange('platform_fee_cap', e, false)}
      />

      <Input
        type='number'
        label='Service Fee %'
        placeholder='Enter percentage'
        className='w-full mt-4'
        inputClass='px-[20px] py-[14px]'
        value={shopDetails?.service_fee ?? ''}
        min={0}
        max={1}
        step={0.01}
        onChange={(e) => handleChange('service_fee', e.target.value, true)}
      />

      <AmountInput
        type='text'
        label='Service Fee Cap (₦)'
        placeholder='Enter cap amount'
        className='w-full mt-4'
        value={shopDetails?.service_fee_cap === 0 ? '' : shopDetails?.service_fee_cap}
        min={0}
        step={1}
        onChange={(e) => handleChange('service_fee_cap', e, false)}
      />

      <SingleBottomNav
        loading={loading}
        onConfirm={handleUpdateShop}
        backBtndisabled
        btnDisabled={loading}
      />
    </div>
  );
};

export default EditShopFees;
